<template lang="pug">
form(
  name='forgotPasswordForm',
  v-on:submit.prevent='submitForgotPassword(userInfo)')
  h1.modal__container--title Reset your password
  .modal__product--divider
  .ui-input
    p Username or Email
    input(
      type='text',
      v-model='userInfo.identifier',
      :disabled='forgotPasswordForm.success',
      placeholder='Your username or email',
      required)

  .modal__product--divider.divider--bottom

  button.btn.btn--purpleLight(
      :class='{ invalid: forgotPasswordForm || forgotPasswordForm.success }'
      type='submit') Reset your password

  .options
    p
      a.link(@click='showLogin') Already have an account?
</template>

<script>
import eventBus from '../eventBus.js';

export default {
  name: 'buyModalForgetPass',
  data() {
    return {
      userInfo: {},
      success: false,
      error: false,
      errormessage: '',
      forgotPasswordForm: '',
    };
  },
  methods: {
    showLogin() {
      eventBus.$emit('showLogin');
    },
    submitForgotPassword(userInfo) {
      eventBus.$emit('submitForgotPass', userInfo);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/buyModalForgetPass.vue